import { PageProps } from "@/types/page";
import { usePage } from "@inertiajs/react";
import axios from "axios";
import { PropsWithChildren, useEffect, useState } from "react";
import {
    CoachSidebarDataContext,
    defaultSidebarData,
    SidebarData,
} from "./CoachSidebarDataContext";

export function CoachSidebarDataProvider({ children }: PropsWithChildren) {
    const { user } = usePage<PageProps>().props;

    const [sidebarData, setSidebarData] =
        useState<SidebarData>(defaultSidebarData);

    const getCoachSidebarData = async () => {
        const { data } = await axios.get<SidebarData | undefined>(
            route("coach.getSidebarData"),
        );
        setSidebarData(data ?? defaultSidebarData);
    };

    useEffect(() => {
        if (user?.type !== "coach") {
            setSidebarData(defaultSidebarData);
            return;
        }
        getCoachSidebarData();
        const interval = setInterval(
            () => {
                getCoachSidebarData();
            },
            1000 * 60 * 15,
        );
        return () => clearInterval(interval);
    }, [user?.type, user?.id]);

    return (
        <CoachSidebarDataContext.Provider
            value={{ ...sidebarData, reloadSidebarData: getCoachSidebarData }}
        >
            {children}
        </CoachSidebarDataContext.Provider>
    );
}
